import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type DmpConnectJSAuthenticationContextAdapter from 'parog-web/contexts/dmpconnect-js/authentication-context-adapter';
import type HealthCentre from 'parog-web/models/health-centre';
import Dropdown from 'ui-kit/components/dropdown';
import { on } from '@ember/modifier';
import type Owner from '@ember/owner';

interface Args {
  context: DmpConnectJSAuthenticationContextAdapter;
  onChange?: (value: string) => void;
}

export default class CnamServicesAccessFormSetPinCodeAndComputterSettingsComputerNetworkSettingsComponent extends Component<Args> {
  @tracked healthCentre: HealthCentre | undefined;

  get selectedHealthCentre(): string | undefined {
    return this.args.context.dmpConnect.selectedHealthCentreForMedic(
      this.args.context.medic
    );
  }

  get windowsUser(): string | undefined {
    return this.args.context.dmpConnect.windowsUserForMedic(
      this.args.context.medic
    );
  }

  set windowsUser(value: string | undefined) {
    this.args.context.dmpConnect.setWindowsUserForMedic(
      this.args.context.medic,
      value
    );
  }

  constructor(owner: Owner, args: Args) {
    super(owner, args);
    this.#refreshHealthCentre();
  }

  setSelectedHealthCentre = (value: string | string[]): void => {
    if (Array.isArray(value)) {
      throw new Error(
        'setSelectedHealthCentre: multiple selection is not supported here'
      );
    }
    this.args.context.dmpConnect.setSelectedHealthCentreForMedic(
      this.args.context.medic,
      value
    );
    this.#refreshHealthCentre();
    this.args.onChange?.(value);
  };

  updateWindowsUser = event => {
    this.windowsUser = event.target.value;
  };

  #refreshHealthCentre(): void {
    this.healthCentre = this.args.context.medic.healthCentres.find(
      hc =>
        hc.finess ===
        this.args.context.dmpConnect.selectedHealthCentreForMedic(
          this.args.context.medic
        )
    );
  }

  <template>
    <div class='field'>
      <Dropdown
        @labelName="Je me connecte sur un ordinateur du réseau de l'établissement"
        @onChange={{this.setSelectedHealthCentre}}
        @selected={{this.selectedHealthCentre}}
        data-test-dropdown='selectedHealthCentre'
        as |dropdown|
      >
        {{#each @context.medic.healthCentres as |hc|}}
          <dropdown.Item @key='{{hc.finess}}' @value='{{hc.name}}' />
        {{/each}}

        <dropdown.Item @key='other-computer' @value='Autre ordinateur' />
      </Dropdown>
    </div>

    {{#if this.healthCentre.dmpHealthCentreConfig.isTseEnv}}
      <div class='field'>
        <label>
          Compte utilisateur Windows
          <input
            class='ui input'
            type='text'
            placeholder='domaine\\\\\\\\utilisateur'
            value={{this.windowsUser}}
            {{on 'input' this.updateWindowsUser}}
          />
        </label>
        <span class='placeholder-label'>
          Votre compte utilisateur Windows est utilisé pour configurer le
          lecteur de carte CPS (DmpConnectJS) sur votre poste.<br />
          Pour le retrouver, lancez l'utilitaire TseCredentials puis coller le
          résultat dans ce champs.
        </span>
      </div>
    {{/if}}
  </template>
}
